import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";

export default function PaymentResult({ status }) {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [state, setState] = useState(status === "cancel" ? "cancel" : "checking");
  const [detail, setDetail] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    if (status === "cancel") return;
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let active = true;
    const poll = async () => {
      if (!active) return;
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/verify/${sid}`);
        setDetail(data);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.payment_status === "expired" || data.payment_status === "failed") { setState("error"); return; }
      } catch {}
      if (attempts.current >= 8) { setState("pending"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { active = false; };
  }, [status, params]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 text-center">
      <Logo size={24} />
      <div className="mt-10">
        {state === "checking" && <><Loader2 size={48} className="animate-spin mx-auto text-neutral-400" /><p className="mt-4 text-neutral-500">Verifica del pagamento…</p></>}
        {state === "paid" && <><CheckCircle2 size={56} className="mx-auto text-emerald-500" /><h1 className="font-display text-2xl font-bold mt-4">Pagamento completato!</h1><p className="text-neutral-500 mt-1">{detail?.title}</p></>}
        {(state === "cancel" || state === "error") && <><XCircle size={56} className="mx-auto text-red-500" /><h1 className="font-display text-2xl font-bold mt-4">Pagamento annullato</h1></>}
        {state === "pending" && <><Loader2 size={48} className="mx-auto text-amber-500" /><h1 className="font-display text-xl font-bold mt-4">In elaborazione</h1><p className="text-neutral-500 mt-1 text-sm">Riceverai una notifica alla conferma.</p></>}
      </div>
      <Button data-testid="payment-back-btn" onClick={() => navigate("/feed")} className="mt-8 h-12 rounded-full bg-black text-white px-8">Torna al feed</Button>
    </div>
  );
}
